import type { ApprovalRequest } from "@uzverse/core";
import { useTranslation } from "react-i18next";

/** One outbound-action approval. Inputs are shown so the user knows exactly what they approve. */
export function ApprovalCard({
  approval,
  onDecide,
}: {
  approval: ApprovalRequest;
  onDecide: (id: string, decision: "approved" | "rejected") => void;
}) {
  const { t } = useTranslation("web");
  const pending = approval.status === "pending";
  const headingId = `approval-${approval.id}`;
  return (
    <article className="card approval" aria-labelledby={headingId}>
      <h3 id={headingId}>{t("approvals.wants", { tool: approval.toolName })}</h3>
      <p className="muted">{t(`approvals.effect.${approval.sideEffect}`)}</p>
      <details>
        <summary>{t("approvals.input")}</summary>
        <pre className="code">{JSON.stringify(approval.input, null, 2)}</pre>
      </details>
      {pending ? (
        <div className="row">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => onDecide(approval.id, "approved")}
          >
            {t("actions.approve", { ns: "common" })}
          </button>
          <button type="button" className="btn" onClick={() => onDecide(approval.id, "rejected")}>
            {t("actions.reject", { ns: "common" })}
          </button>
        </div>
      ) : (
        <p role="status" className="chip chip-ok">
          {t(`approvals.status.${approval.status}`)}
        </p>
      )}
    </article>
  );
}
